import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    loading: false,
    dataOfSearchFields: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    //form specific:
    userData: {},

    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    userWasCreated: false,
    userWasEdited: false,
    userWasDeleted: false,
  
    error: undefined
};

const usersReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_DATA_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                dataOfSearchFields: {
                    ...state.dataOfSearchFields,
                    [payload.id]: {
                        ...state.dataOfSearchFields[payload.id],
                        data: payload.value
                    }
                }
            };
        case actionTypes.SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.USER_SEARCH_REQUEST:
            return {
                ...state,
                loading:true
            };
        case actionTypes.USER_SEARCH_SUCCESS:
            return {
                ...state,
                loading:false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_USER_REQUEST:
            return {
                ...state,
                loading:true,
            };
        case actionTypes.GET_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                userData: payload,
            };
        case actionTypes.GET_USER_FAILED:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case actionTypes.DELETE_USER_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_USER_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                userWasDeleted: true
            };
        case actionTypes.DELETE_USER_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                userWasDeleted: false
            };
        case actionTypes.EDIT_USER_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_USER_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                userWasEdited: true
            };
        case actionTypes.EDIT_USER_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                userWasEdited: false
            };
        case actionTypes.CREATE_USER_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_USER_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                userWasCreated: true
            };
        case actionTypes.CREATE_USER_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                userWasCreated: false
            };
        case actionTypes.RESET_USER_FORM:
            return {
                ...state,
                userData: {},
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                userWasCreated: false,
                userWasEdited: false,
                userWasDeleted: false,
                error: undefined
            };
        default:
            return state;
    }
};

export default usersReducer;